<template>
    <div class="flex flex-column">
        <h6 class="titulo m-0 mb-2" style="font-size: 0.813rem">
            {{ titulo }}
        </h6>

        <strong class="dado line-height-2 p-0 m-0" style="font-size: 1rem">
            <slot></slot>
        </strong>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
        },
        fonteRegularTitulo: {
            type: Boolean,
        },
        fonteRegularDado: {
            type: Boolean,
        },
    },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.titulo {
    color: #282a3160;
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}

.dado {
    color: #282a31;
    font-family: 'Lato', Arial, sans-serif;
    font-weight: 700;
}
</style>
